import { ISoftData, ICategorys } from "@/common/interface";
import Link from "@/components/common/Link";
import MySwiper from "@/components/common/MySwiper";
import { IIndexState } from "@/store/index";
import React, { useRef, useEffect, useState } from "react";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { connect } from "react-redux";
import { SwiperOptions } from "swiper";
import "./index.scss";
import Img from "@/components/common/Img";
import { comMonitor } from "@/utils/com";

interface IProps {
  data: ISoftData[];
}

const option: SwiperOptions = {
  effect: "coverflow",
  coverflowEffect: {
    rotate: 0,
    stretch: 180,
    depth: 100,
    modifier: 1,
    slideShadows: true,
  },
  centeredSlides: true,
};

const Banner = (props: IProps) => {
  const { data } = props;

  const nodeRef = useRef<HTMLDivElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });
  // const { soft_id, name } = items.data[index];
  // console.log("data is",items.data )

  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && data[0].soft_id) {
      const monitorIds = data
        .reduce<string>((prev, current) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);

      const params = {
        cid: `mainbanner`, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = data.filter((item) => {
        return item.imptk;
      });
      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, data, lock, ratio]);

  // const [startTime, setStartTime] = useState(0);

  const slides = data.map(
    (
      {
        href = "",
        url = "",
        name = "",
        soft_id,
        open_type,
        exec,
        ads,
        category,
        clktk,
      },
      index,
    ) => {
      // const onMouseDown = (e: React.MouseEvent) => {
      //   e.stopPropagation();
      //   e.preventDefault();
      //   setStartTime(Date.now());
      // };

      // const onMouseUp = (e: React.MouseEvent) => {
      //   if (Array.isArray(clktk) && clktk.length) {
      //     clktk.forEach(url => {
      //       const realUrl = replaceUrlTemplate(url, e, startTime, Date.now());
      //       comMonitor(realUrl);
      //     });
      //   }
      // };
      return (
        <div key={`${soft_id}-${category}-${index}`} className="swiper-slide">
          <Link
            softId={soft_id}
            href={href}
            openType={open_type}
            exec={exec}
            dataText={`${category && ICategorys[category]}`}
            ads={ads}
            comAds={clktk}
            name={name}
            position="mainbanner"
            category={category}
            style={{ display: "block" }}
          >
            <Img src={url} />
          </Link>
        </div>
      );
    },
  );

  return (
    <div ref={nodeRef} className="banner" data-bk="banner">
      <MySwiper position="mainbanner" id="bannerSwiper" option={option}>
        {slides}
      </MySwiper>
    </div>
  );
};

const mapStateToProps = ({ indexData: { banner } }: IIndexState) => ({
  data: banner,
});

export default connect(mapStateToProps)(Banner);
